import { CheckoutRequest } from "@/app/checkout/(squeeze)/review/checkoutReviewPage";

export default async function getCheckoutResponse(
  checkoutRequest: CheckoutRequest | null,
): Promise<CheckoutResponse | null | string> {
  try {
    const response = await fetch("/rest/neo/checkout/v1/display", {
      credentials: "include",
      method: "POST",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(checkoutRequest),
    });
    if (response.ok) {
      const responsePayload = (await response.json()) as CheckoutResponse;
      console.log(responsePayload);
      return responsePayload;
    }
    if (response.status === 401) {
      return "UNATHORIZED";
    }
    return await getServerError(response);
  } catch (error) {
    return null;
  }
}

async function getServerError(response: Response): Promise<string> {
  try {
    const error = await response.text();
    return JSON.parse(error)[0]?.message || "An unknown error occurred";
  } catch (error) {
    return "An unknown error occurred";
  }
}

export type VendorDeliveryDates = {
  fromDate: Date;
  toDate: Date;
  twoDayDeliveryDate?: Date;
};

export type CheckoutOrder = ShoppingCartVendorOrder & {
  vendorDeliveryDates?: VendorDeliveryDates;
  totalTax: number;
};

type FirstPartyDetails = {
  name: string;
  phone: string;
  email: string;
  address: string;
  firstName: string;
  lastName: string;
};

export type CheckoutResponse = {
  subTotal: number;
  standardShipping: number;
  heavyShipping: number;
  retailTotal: number;
  retailPrice: number;
  retailDeliveryFee: number;
  totalTax: number;
  savings: number;
  total: number;
  coId?: number;
  ugrId?: number;
  emailAddress: string;
  ccEmailList?: string[];
  vendorOrders: CheckoutOrder[];
  firstOrderDate: string;
  isFirstOrder: boolean;
  noOfOrders: number;
  totalGMV: number;
  statusCode: string;
  statusMessage: string;
  firstPartyDetails?: FirstPartyDetails;
  amplifiedPLTVScore?: number;
};
